export const PUBLIC_NO_DEPOSIT_UPSELL_ROUTES = {
  LET_ME_TELL_YOU: 'PUBLIC:NO_DEPOSIT_UPSELL:LET_ME_TELL_YOU',
  LET_ME_TELL_YOU_FEEDBACK: 'PUBLIC:NO_DEPOSIT_UPSELL:LET_ME_TELL_YOU_FEEDBACK'
};
